import React, { useContext } from 'react';
import { PlaybackInformationAdPlayback } from './PlaybackInformationAdPlayback';
import { PlaybackInformationContent } from './PlaybackInformationContent';
import { PlaybackInformationContext, PlaybackInformationContextProvider, PlaybackInformationProps } from '../../../contexts/PlaybackInformationContext';

const PlaybackInformationContentWrapper: React.FC = () => {
	const { player } = useContext(PlaybackInformationContext);

	if (player?.isAdPlayback()) {
		return <PlaybackInformationAdPlayback />;
	}

	return <PlaybackInformationContent />;
};

export const PlaybackInformation: React.FC<PlaybackInformationProps> = (props) => {
	return (
		<PlaybackInformationContextProvider {...props}>
			<PlaybackInformationContentWrapper />
		</PlaybackInformationContextProvider>
	);
};
